export interface DSIItem {
    settingsId: number,
    description: string
}

export interface DSIUserDismissItem {
    userId: string,
    userName: string
}

export interface DSISearchItem {
    recordId: number,
    patientId: number,
    patientName: string,
    description: string,
    feedback?: string,
    userName: string,
    dismissDate: string,
    location: string,
    actionTaken: string
}

export interface DSISearchInputs {
    startDate?: string,
    stopDate?: string,
    settingsId?: number,
    searchUserId?: string,
    patientId?: number,
    actionTaken?: number
}

export interface DSIAddInputs {
    patientId: number,
    identifier: string,
    reason?: string,
    dismissed: boolean
}

export enum DSIDetailType {
    NotAvailable = "N",
    URL = "U",
    eDocumentId = "E"
}

export interface DSIDetails {
    alert?: string,
    citation?: string,
    developer?: string,
    fundingSource?: string,
    release?: string,
    guideline?: string,
    dismissed?: boolean,
    type?: string,
    detailType?: DSIDetailType,
    detailUrl?: string,
    detailId?: string,
    triggerRace?: boolean,
    triggerEthnicity?: boolean,
    triggerLanguage?: boolean,
    triggerSex?: boolean,
    triggerOrientation?: boolean,
    triggerGenderIdentity?: boolean,
    triggerBirthDate?: boolean
}